var React = require('react');

function IconAdd (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Add icon"),React.createElement("desc",{"key":1},"Add icon"),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":2},[React.createElement("circle",{"cx":"12","cy":"12","r":"12","fill":"#DAE7F0","key":0}),React.createElement("g",{"stroke":"#3F7BAB","key":1},React.createElement("path",{"d":"M12 8v8M16 12H8"}))])]);
}

IconAdd.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","role":"img"};

module.exports = IconAdd;

IconAdd.default = IconAdd;
